import React from 'react';

export const ArrowIcon = () => {
  return (
    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 13.5l-5.5-3-5.5 3" stroke="currentColor" fill="none" />
    </svg>
  );
};

export default ArrowIcon;
